<a [href]="playStoreURL" target="_blank" *ngIf="playStoreURL !== undefined && isShow">
    <img [src]="playStoreImage" class="app-play-store-image play-store-image" >
</a>